module.exports = __webpack_public_path__ + "9660fb1489142f8b793feb303043c7ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover2.jpg
// module id = 852
// module chunks = 3